import { Component } from '@angular/core';

@Component({  
  standalone: true,
  template: '<h1>Not Found</h1>',  
})

export class NotFoundComponent {
   
  constructor() {    
  }

}

